<div class="w-screen flex">
  <div class="w-20">
    <!--Add dynamic component -->
    <ng-template sipLoadCompHelper></ng-template>
  </div>
  <div class="flex justify-between">
    <ul class="flex -ml-2">
      <!--Regular Link-->
      @for (item of navList; track item; let i = $index) {
        <li
          class="sub-navigation-li"
          [ngClass]="subNavListStyle"
          >
          <a
            [routerLink]="[item.path]"
            (click)="getActiveClass($event)"
            class="sub-navigation-anchor text-xs"
            [ngClass]="subNavAnchorStyle"
            ><span [routerLinkActive]="activeLink">
            @if (item?.icon) {
              <img
                [src]="item.icon"
                class="inline -mt-1"
                alt="icon"
              />
            }
            {{ item.label }}</span
            ></a
            >
          </li>
        }
      </ul>
    </div>
  </div>
